<div class="zen-ai-assistant" [ngClass]="{ expanded: isExpanded }">
  <div class="zen-ai-header" (click)="toggleExpand()">
    <div class="zen-ai-header-content">
      <img src="assets/images/common/ai-sparkle.svg" alt="AI" class="zen-ai-icon" />
      <span class="zen-ai-title">Ask ZenAI</span>
    </div>
    <div class="zen-ai-header-actions">
      @if (isExpanded && messages.length > 1) {
        <img
          src="assets/images/common/refresh.svg"
          alt="Clear"
          class="zen-ai-action-icon"
          (click)="clearConversation(); $event.stopPropagation()"
          title="Clear conversation"
        />
      }
      <img
        [src]="isExpanded ? 'assets/images/arrows/arrow-down.svg' : 'assets/images/arrows/empty-arrow-down.svg'"
        alt="Toggle"
        class="zen-ai-toggle-icon"
        [ngClass]="{ 'rotate-180': !isExpanded }"
      />
    </div>
  </div>

  @if (isExpanded) {
    <div class="zen-ai-body">
      <div #messagesContainer class="zen-ai-messages" (scroll)="onMessagesScroll($event)">
        @for (message of messages; track message.timestamp) {
          @if (message.status === ZenAiMessageStatus.Reasoning && !message.isUser) {
            <!-- Show shimmer box for reasoning status messages (system status or LLM thinking) -->
            <div class="zen-ai-message ai-message">
              <div class="message-content loading">
                <div class="shimmer-loader">
                  <div class="shimmer-text-line">
                    <span class="shimmer-text">{{ message.text }}</span>
                    <div class="shimmer-bar"></div>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <!-- Regular message (streaming or complete) -->
            <app-zen-ai-message [message]="message"></app-zen-ai-message>
          }
        }
      </div>

      <app-zen-ai-input
        [queryControl]="queryControl"
        [isLoading]="isLoading"
        (send)="sendQuery()"
        (keyPress)="onKeyPress($event)"
      ></app-zen-ai-input>
    </div>
  }
</div>
